module.exports = __webpack_public_path__ + "images/ccare_hangout.png";